<template>
    <h1>Gallery</h1>
    <AppProductsList />

    <teleport to="#app-sidebar">
        <AppCart />
    </teleport>
</template>

<script>
import AppCart from "@/components/app/Cart";
import AppProductsList from "@/components/app/ProductsList";

export default {
    components: { AppCart, AppProductsList },
    name: "",
    data: () => ({

    })
}
</script>
